<template>
  <div class="cx-month-cell" :class="{ 'cx-month-cell--current': isCurrentMonth() }">
    {{ monthText }}
    <div v-if="isActiveMonth" class="dp__marker_dot"></div>
  </div>
</template>

<script setup lang="ts">

interface Props {
  monthText: string,
  selectedYear: number,
  monthValue: number,
  isActiveMonth: boolean
}

const props = defineProps<Props>();

const isCurrentMonth = () => {
  const today = new Date();
  return (today.getFullYear() === props.selectedYear) && (today.getMonth() === props.monthValue);
};
</script>